export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      title: 'Rafan Group',
      subtitle: 'Leading Qatar Since 2011',
      description: 'A premier Qatari holding company delivering excellence across automotive, tourism, construction, and real estate sectors.',
      cta: 'Explore Our Services',
      pioneer: 'Established 2011'
    },
    services: {
      title: 'Our Business Divisions',
      subtitle: 'Six pillars of excellence serving Qatar',
      carRental: {
        title: 'Car Rental',
        description: 'Premium fleet of vehicles for short and long-term rentals with 24/7 customer service.'
      },
      chauffeur: {
        title: 'Chauffeur Service',
        description: 'Professional drivers providing luxury transportation for business and personal needs.'
      },
      tours: {
        title: 'Tours & Travels',
        description: 'Comprehensive travel solutions including city tours, desert safaris, and customized itineraries.'
      },
      usedCars: {
        title: 'Used Cars',
        description: 'Certified pre-owned vehicles with quality guarantee and transparent pricing.'
      },
      construction: {
        title: 'Construction',
        description: 'Building Qatar\'s future with innovative construction solutions and project management.'
      },
      realEstate: {
        title: 'Real Estate',
        description: 'Property development, sales, and leasing services across prime Qatar locations.'
      }
    },
    about: {
      title: 'About Rafan Group',
      content: 'With roots dating back to 2011, Rafan Group represents a legacy of excellence in Qatar\'s business landscape. As a distinguished Qatari holding company, we bring together years of expertise across diverse sectors. Our commitment to quality and customer satisfaction has made us a trusted name in automotive services, tourism, construction, and real estate.'
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Ready to work with us? Contact our team',
      form: {
        name: 'Your Name',
        email: 'Email Address',
        phone: 'Phone Number',
        service: 'Service Interested In',
        message: 'Your Message',
        submit: 'Send Message',
        selectService: 'Select a service'
      },
      info: {
        call: 'Call Us',
        whatsapp: 'WhatsApp',
        email: 'Email Us'
      }
    },
    footer: {
      tagline: 'Leading Qatar Since 2011',
      rights: 'All rights reserved.',
      divisions: 'Our Divisions'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'مجموعة رافان',
      subtitle: 'رائدون في قطر منذ 2011',
      description: 'شركة قطرية رائدة تقدم التميز في قطاعات السيارات والسياحة والبناء والعقارات.',
      cta: 'استكشف خدماتنا',
      pioneer: 'تأسست 2011'
    },
    services: {
      title: 'أقسامنا التجارية',
      subtitle: 'ستة أعمدة من التميز في خدمة قطر',
      carRental: {
        title: 'تأجير السيارات',
        description: 'أسطول متميز من المركبات للإيجار قصير وطويل الأجل مع خدمة عملاء على مدار الساعة.'
      },
      chauffeur: {
        title: 'خدمة السائق',
        description: 'سائقون محترفون يوفرون خدمة نقل فاخرة للأعمال والاحتياجات الشخصية.'
      },
      tours: {
        title: 'الجولات والسفر',
        description: 'حلول سفر شاملة تشمل جولات المدينة ورحلات الصحراء وبرامج مخصصة.'
      },
      usedCars: {
        title: 'السيارات المستعملة',
        description: 'مركبات معتمدة ومفحوصة مع ضمان الجودة وأسعار شفافة.'
      },
      construction: {
        title: 'البناء',
        description: 'نبني مستقبل قطر من خلال حلول البناء المبتكرة وإدارة المشاريع.'
      },
      realEstate: {
        title: 'العقارات',
        description: 'تطوير العقارات والمبيعات والتأجير في أفضل المواقع في قطر.'
      }
    },
    about: {
      title: 'عن مجموعة رافان',
      content: 'مع جذور تعود إلى عام 2011، تمثل مجموعة رافان إرثاً من التميز في المشهد التجاري القطري. كشركة قطرية مرموقة، نجمع سنوات من الخبرة عبر قطاعات متنوعة. التزامنا بالجودة ورضا العملاء جعلنا اسماً موثوقاً في خدمات السيارات والسياحة والبناء والعقارات.'
    },
    contact: {
      title: 'تواصل معنا',
      subtitle: 'هل أنت مستعد للعمل معنا؟ اتصل بفريقنا',
      form: {
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        service: 'الخدمة المهتم بها',
        message: 'رسالتك',
        submit: 'إرسال الرسالة',
        selectService: 'اختر خدمة'
      },
      info: {
        call: 'اتصل بنا',
        whatsapp: 'واتساب',
        email: 'البريد الإلكتروني'
      }
    },
    footer: {
      tagline: 'رائدون في قطر منذ 2011',
      rights: 'جميع الحقوق محفوظة.',
      divisions: 'أقسامنا'
    }
  }
};